/** The confirmation summary table — the prototype's `.confirm-summary` /
 * `.confirm-row` (subscription-portal.html): label on the left, bold value
 * on the right, one fact per row, rows divided by a hairline; with `total`,
 * the last row is the emphasised `.confirm-row.total`. Shared by the
 * purchase confirmation (MS-820) and the admin confirmation (MS-821). */
export function ConfirmSummary({
  rows,
  total = false,
  className = '',
}: Readonly<{
  rows: readonly { label: string; value: string }[]
  total?: boolean
  className?: string
}>) {
  return (
    <div className={`border border-[var(--border-light)] rounded-lg overflow-hidden ${className}`}>
      {rows.map((row, i) => {
        const isTotal = total && i === rows.length - 1
        return (
          <div
            key={row.label}
            data-testid="confirm-row"
            className={`flex justify-between gap-4 px-3.5 py-[9px] text-[12.5px] text-[var(--text-primary)] ${
              i > 0 ? 'border-t border-[var(--border-light)]' : ''
            } ${isTotal ? 'bg-[var(--bg-app)]' : ''}`}
          >
            <span>{row.label}</span>
            <strong className={`tabular-nums text-right ${isTotal ? 'text-[14px]' : ''}`}>{row.value}</strong>
          </div>
        )
      })}
    </div>
  )
}
